<div class="users-qualification mt-24">
  <!-- Фильтр по территории: по нему отбираются сотрудники для редактирования -->
  <div class="filter pos-r">
    <app-loader *ngIf="isFiltersLoading"></app-loader>
    <div class="grid">
      <div class="grid__box grid__box--size-3">
        <div class="users-qualification__label mb-8">Регион</div>
        <div class="field field--select">
          <app-select [items]="regions" [initBy]="selectedRegion" [textKey]="'name'" [defaultText]="'Выберите регион'" (callback)="onChangeRegion($event)"></app-select>
        </div>
      </div>
      <div class="grid__box grid__box--size-3">
        <div class="users-qualification__label mb-8">Филиал</div>
        <div class="field field--select">
          <app-select
            [items]="branches"
            [initBy]="selectedBranch"
            [textKey]="'mb_name'"
            [defaultText]="selectedRegion ? 'Выберите филиал' : 'Выберите регион'"
            [isDisabled]="branches.length === 0"
            (callback)="onChangeBranch($event)"
          ></app-select>
        </div>
      </div>
      <div class="grid__box grid__box--size-3">
        <div class="users-qualification__label mb-8">Участок</div>
        <div class="field field--select">
          <app-select
            [items]="sectors"
            [initBy]="selectedSector"
            [textKey]="'sector_number_str'"
            [defaultText]="!selectedRegion ? 'Выберите регион' : !selectedBranch ? 'Выберите филиал' : 'Выберите участок'"
            [isDisabled]="sectors.length === 0"
            (callback)="onChangeSector($event)"
          ></app-select>
        </div>
      </div>
      <div class="users-qualification__filter-actions grid__box grid__box--size-min">
        <div class="grid grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <button type="button" class="button button--primary" [disabled]="!selectedRegion" (click)="applyFilter()">Применить</button>
          </div>
          <div class="grid__box grid__box--size-min">
            <a class="link link--dotted-blue-dark" (click)="resetFilter()">Сбросить</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="users-qualification__loader padding-24 pos-r" *ngIf="isLoading">
    <app-loader></app-loader>
  </div>

  <app-message [type]="'error'" *ngIf="error && !isLoading">
    <div message-content>
      {{ error }}
      <a class="link link--dotted-blue-dark ml-8" (click)="loadEmployees(false)">Повторить</a>
    </div>
  </app-message>

  <ng-container *ngIf="!isLoading && !error">
    <app-message [type]="'error'" [size]="'small'" *ngIf="saveError">
      <div message-content>{{ saveError }}</div>
    </app-message>

    <app-message [type]="'success'" [size]="'small'" *ngIf="successMessage && !saveError">
      <div message-content>{{ successMessage }}</div>
    </app-message>

    <ng-container *ngIf="isFilterApplied; else selectFilters">
    <div class="users-qualification__count mt-16">Найдено сотрудников: {{ employeesTotal }}</div>

    <div class="users-qualification__legend mt-8">
      <span class="users-qualification__chip users-qualification__chip--new-connection">Новое подключение</span>
      <span class="users-qualification__chip users-qualification__chip--other">Другие работы</span>
      <span class="users-qualification__chip users-qualification__chip--incident">Работы по ГП</span>
    </div>

    <div class="users-qualification__table mt-8">
      <table class="tbl tbl--full">
        <thead>
          <tr>
            <th>Сотрудник</th>
            <th>Квалификации</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of employeeRows">
            <tr
              class="users-qualification__employee-row"
              [class.users-qualification__employee-row--editing]="row.isEditing"
            >
              <td class="users-qualification__name-cell">{{ row.name }}</td>
              <td>
                <span class="users-qualification__missing" *ngIf="!row.codesLoaded">Не удалось загрузить</span>
                <ng-container *ngIf="row.codesLoaded && row.codes.length; else noQualifications">
                  <span class="users-qualification__chip" [ngClass]="getQualificationChipClass(code)" *ngFor="let code of getVisibleCodes(row)">
                    {{ getQualificationName(code) }}
                    <ng-container *ngTemplateOutlet="subtypesInfo; context: { code: code }"></ng-container>
                  </span>
                  <a class="link link--dotted-blue-dark users-qualification__toggle" *ngIf="canToggleCodes(row)" (click)="toggleCodesExpanded(row)">
                    {{ row.isExpanded ? 'свернуть' : 'ещё ' + getHiddenCodesCount(row) }}
                  </a>
                </ng-container>
                <ng-template #noQualifications>
                  <ng-container *ngIf="row.codesLoaded">—</ng-container>
                </ng-template>
              </td>
              <td class="users-qualification__action-cell">
                <a class="link link--dotted-blue-dark" *ngIf="!row.isEditing && row.codesLoaded" (click)="startEditing(row)">Редактировать</a>
                <span
                  class="users-qualification__label"
                  *ngIf="!row.isEditing && !row.codesLoaded"
                  title="Квалификации сотрудника не загрузились — редактирование заблокировано, иначе сохранение стёрло бы реальный набор"
                >
                  Редактирование недоступно
                </span>
                <a class="link link--dotted-gray-dark" *ngIf="row.isEditing" (click)="cancelEditing(row)">Свернуть</a>
              </td>
            </tr>
            <tr class="users-qualification__editor-row tr--reset-highlight" *ngIf="row.isEditing">
              <td colspan="3">
                <div class="mb-8">
                  <a class="link link--dotted-blue-dark" (click)="checkAllCodes(row)">Заполнить все</a>
                  <a class="link link--dotted-gray-dark ml-16" (click)="uncheckAllCodes(row)">Удалить все</a>
                </div>
                <div class="users-qualification__checkboxes">
                  <app-checkbox *ngFor="let qualification of qualifications">
                    <input
                      type="checkbox"
                      [checked]="row.checkedCodes[qualification.id]"
                      [disabled]="row.isSaving"
                      (change)="toggleCode(row, qualification.id, $event.target.checked)"
                    />
                    <checkbox-text>
                      <span class="users-qualification__chip" [ngClass]="getQualificationChipClass(qualification.id)">
                        {{ qualification.name }}
                        <ng-container *ngTemplateOutlet="subtypesInfo; context: { code: qualification.id }"></ng-container>
                      </span>
                    </checkbox-text>
                  </app-checkbox>
                </div>

                <div class="grid grid--va-middle mt-16">
                  <div class="grid__box grid__box--size-min">
                    <button type="button" class="button button--primary" [disabled]="row.isSaving" (click)="saveRow(row)">Сохранить</button>
                  </div>
                  <div class="grid__box grid__box--size-min">
                    <a class="link link--dotted-gray-dark" (click)="cancelEditing(row)">Отмена</a>
                  </div>
                  <div class="grid__box grid__box--size-min users-qualification__label">Отмечено: {{ getCheckedCodes(row).length }}</div>
                </div>

                <div class="users-qualification__hint mt-8">
                  Сохраняется полный набор: снятые галочки удалят квалификацию, если не отмечено ничего — у сотрудника не останется ни одной.
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="employeeRows.length === 0">
            <td colspan="3" class="ta-center">Сотрудники не найдены</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-16 ta-center" *ngIf="hasMoreEmployees">
      <button type="button" class="button" (click)="loadMoreEmployees()">Показать ещё</button>
    </div>
    </ng-container>

    <ng-template #selectFilters>
      <div class="users-qualification__empty mt-16">Выберите регион, при необходимости филиал и участок, и нажмите «Применить» — сотрудники появятся после применения фильтра.</div>
    </ng-template>
  </ng-container>
</div>

<!-- Значок «i» с подтипами заявки. Нативный title Chrome не показывает, если подсказка не влезает в экран,
     поэтому это поповер в body с раскладкой длинных списков в колонки -->
<ng-template #subtypesInfo let-code="code">
  <ng-container *ngIf="getQualificationSubtypes(code) as subtypes">
    <ng-template #subtypesHint>
      <div class="users-qualification__subtypes" [ngClass]="getSubtypesClass(subtypes)">
        <div class="users-qualification__subtype" *ngFor="let subtype of subtypes">{{ subtype }}</div>
      </div>
    </ng-template>
    <span
      class="users-qualification__info"
      *ngIf="subtypes.length"
      [ngbPopover]="subtypesHint"
      triggers="mouseenter:mouseleave"
      container="body"
      placement="auto"
      popoverClass="users-qualification__popover"
    >
      <app-icon [glyph]="'round-e-help'" [size]="'12'"></app-icon>
    </span>
  </ng-container>
</ng-template>
